var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.audio === 'unmuteAudio')?_c('div',{staticClass:"aec"},[_c('div',{staticClass:"aec_content",style:({ transform: `translateY(-${_vm.micLevel}%)` })})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }